import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, groupBy } from 'rxjs/operators';
import { TokenStorageService } from '../auth/token-storage.service';
import { AppConfig } from '../../app-config';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class AuditoriasService {

  AUTH_API = "";

  constructor(private http: HttpClient,
              private tokenStorage: TokenStorageService,
              private appConfig:AppConfig
              ) {
                this.AUTH_API = appConfig.api_url;
              }

  getAll(filtros): Observable<any> {
    return this.http.post(this.AUTH_API + 'logs/all',filtros.value, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  countAll(filtros): Observable<any> {
    return this.http.post(this.AUTH_API + 'logs/count',filtros.value, httpOptions).pipe(tap(evaluacion => {
        return evaluacion;
    }));
  }
  /*
  getAll(formData: any): Observable<any> {
    return this.http.get(this.AUTH_API + `logs/all/pag/${formData.pagina}/limit/${formData.cantidad}`, httpOptions);
  }*/

}
